// contexts/LoadContext.tsx
import type React from 'react'
import { createContext, useContext } from 'react'
import { useLoads } from '../hooks/useLoads'
import type { LoadResponse } from '../services/loadService'

interface LoadContextType {
  loads: LoadResponse[]
  isLoading: boolean
  error: Error | null
  getLoadsByTag: (tagId: string) => Promise<void>
}

const LoadContext = createContext<LoadContextType | undefined>(undefined)

export const LoadProvider = ({ children }: { children: React.ReactNode }) => {
  // This state will be shared across all components
  const loadsData = useLoads()

  return (
    <LoadContext.Provider value={loadsData}>{children}</LoadContext.Provider>
  )
}

// Hook to use the shared loads data
export const useLoadContext = () => {
  const context = useContext(LoadContext)
  if (!context) {
    throw new Error('useLoadContext must be used within a LoadProvider')
  }
  return context
}
